import { initialState } from "./init";
import { SET_SURGERY_MODE } from "./actions";

export default function SurgeryModeReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_SURGERY_MODE:
            return setSurgeryMode(state, action);
        default:
            return state;
    }
}

function setSurgeryMode(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.autoLogoutPaused = action.isOn;
    return stateCpy;
}
